import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import Api from '../services/Api';
import KycMetaInfo from './KycMetaInfo';
import Skeleton from 'react-loading-skeleton';
import KycSection from './KycSection';
import {forEach, keyBy, map, mapValues} from 'lodash';
import {store} from '../AppRenderer';

class KycInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      kycInfo: null,
    };
    this.kycItems = keyBy(store.getState().app.kycItems, 'name');
  }

  async componentDidMount() {
    await this.fetchData();
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.kycInfo && prevState.kycInfo.level !== this.props.profile.kycLevel) {
      this.setState({
        kycInfo: {
          ...this.state.kycInfo,
          level: this.props.profile.kycLevel,
        },
      });
    }
  }

  fetchData = async () => {
    const data = await this.fetchKycInfo();
    this.setState({
      kycInfo: {
        ...data,
        ...(this.injectItemsValue(data.kycItemsInfo, this.kycItems))
      },
    });
  }

  fetchKycInfo = async () => {
    const {userId} = this.props;
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/user-kyc', null, {
        params: {
          userId,
        },
      });
      return data;
    } catch (e) {
      console.log('error: ', e);
    }
  };

  injectItemsValue = itemsInfo => {
    let itemsValue = null;
    forEach(itemsInfo, (obj, key) => {
      if (this.kycItems[key].subItems) {
        itemsValue = {
          ...itemsValue,
          ...(obj.value ?
            mapValues(keyBy(map(this.kycItems[key].subItems, (name, index) => {
              return {name, value: obj.value.split(',')[index]};
            }), 'name'), 'value') : {}),
        };
      } else {
        itemsValue = {
          ...itemsValue,
          [key]: obj.value,
        };
      }
    });
    return itemsValue;
  };

  render() {
    const {kycInfo} = this.state;
    const {profile, fetchProfile, userId} = this.props;
    if (profile && kycInfo) {
      const {userGroup, zarinpalId} = profile;
      const {kyc_policy} = userGroup.attributes;
      return (
        <div>
          <KycMetaInfo
            userId={userId}
            kycInfo={kycInfo}
            zarinpalId={zarinpalId}
            fetchProfile={fetchProfile}
            levels={kyc_policy.levels.map(obj => obj.level)}
            automatedLevelEvaluation={profile.automatedLevelEvaluation}
          />
          {kyc_policy.levels.map(obj => (
            obj.items.length ?
            <KycSection
              key={obj.level}
              level={obj}
              userId={userId}
              kycInfo={kycInfo}
              kycItems={this.kycItems}
            /> : null
          ))}
        </div>
      );
    }
    return <Skeleton count={4} height={300} className='my-5'/>;
  }
}

export default withTranslation()(KycInfo);